export default "__VITE_ASSET__66f7086c__"